import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DriverBankTransactionReason extends AbstractModel {
  @autoserialize name: string;

  @autoserialize description: string;
}
